import Common from '@/libs/common';
import type { LatLong } from '@/stores/app';

/** Crow-fly radius under which a stop counts as "near you", shared by every view showing it. */
export const NEARBY_STOP_RADIUS_M = 500;

/**
 * Wider radius used along a single route: its stops can be far apart, and the
 * passenger still wants the list to open on the one they are closest to.
 */
export const ROUTE_NEAREST_STOP_RADIUS_M = 3000;

interface Located {
  stop_lat: number;
  stop_lon: number;
}

/** The stop nearest to the position, or undefined when none lies within the radius. */
export function findNearestStop<T extends Located>(
  position: LatLong,
  stops: T[],
  maxDistance: number = NEARBY_STOP_RADIUS_M,
): T | undefined {
  let nearest: T | undefined;
  let nearestDistance = maxDistance;
  stops.forEach(stop => {
    const distance = Common.coordDistance(
      { latitude: position.lat, longitude: position.lon },
      { latitude: stop.stop_lat, longitude: stop.stop_lon },
    );
    if (distance <= nearestDistance) {
      nearestDistance = distance;
      nearest = stop;
    }
  });
  return nearest;
}
